import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { StoreInterfaces } from "../../../types/store/StoreInterfaces";
import MenuContent from "./MenuContent";
import OptionsMenu from "../Menus/OptionsMenu";
import ViewSwitcher from "./ViewSwitcher";

const drawerWidth = 280;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: "border-box",
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: "border-box",
  },
});

export default function SideMenu() {
  const session = useSelector((state: StoreInterfaces) => state.session);
  const userName = session?.name ?? session?.email;

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", md: "block" },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: "background.paper",
        },
      }}
    >
      {!session.isAdministrator && (
        <>
          <Box
            sx={{
              display: 'flex',
              mt: 'calc(var(--template-frame-height, 0px) + 4px)',
              p: 1.5,
            }}
          >
            <ViewSwitcher />
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent />
      </Box>

      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: "center",
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Avatar sx={{ width: 36, height: 36 }}>
          {userName?.[0]?.toUpperCase()}
        </Avatar>

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
          }}
        >
          <Typography
            variant="body2"
            noWrap
            sx={{
              fontWeight: 500,
            }}
          >
            {userName}
          </Typography>

          <Typography
            variant="caption"
            noWrap
            sx={{
              display: "block",
              color: "text.secondary",
              fontSize: "0.7rem",
            }}
          >
            {session?.email}
          </Typography>
        </Box>

        <OptionsMenu />
      </Stack>
    </Drawer>
  );
}